import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  color: rgb(28 35 44 / 60%);
  padding: 0 36px;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
`;

export const Title404 = styled.p`
  color: var(--colorBlueGray1200);
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 10px;
`;
